<template>
  <div v-if="profileModal" class="profile-modal d-flex justify-content-center" @click.self="closeProfileModal">
      <div class="inside-profile-modal">
           <div class="d-flex flex-row justify-content-center profile-header">
                <span>Connected with metamask</span>
                <button class="close-button" @click="closeProfileModal">x</button>
            </div>
            <div class="d-flex flex-row justify-content-center mt-5 ">
                <span class="windows-command-prompt wallet-id mx-3">
                    {{walletId.slice(0,4)}}...{{walletId.slice(walletId.length - 4,walletId.length)}}
                </span>
                <img src="../assets/images/profile.webp" class="mx-3" alt="">
            </div>
            <div class="d-flex flex-row justify-content-center mt-5">
                <button class="profile-add-eggs-button windows-command-prompt mx-3" @click="addEGGS">
                Add $EGGS
                </button>
                <button class="profile-add-eggs-button windows-command-prompt mx-3" @click="addEGGS">
                Buy $EGGS
                </button>
            </div>
            <div class="d-flex flex-row justify-content-center profile-footer windows-command-prompt">
                <button class="profile-disconnect-button" @click="disconnect">
                    Disconnect</button>
            </div>
      </div>
  </div>
</template>

<script>
import addToken from '../scripts/addToken'
export default {
    name:'profile-modal',
    props:{
        profileModal:{
            default:false,
            type:Boolean
        },
        walletId:{
            default:'',
            type:String
        }
    },
    methods:{
        closeProfileModal(){
            this.$emit('profileModal' , false)
        },
        addEGGS(){
            console.log("clicked")
            addToken.addToken()
        },
        disconnect(){
            this.closeProfileModal()
            this.$emit('disconnect' , true)
        }
    }
}
</script>

<style scoped>
.profile-modal{
    position: fixed;
    top: 0;
    left: 0;
    z-index: 1055;
    display: block;
    width: 100%;
    height: 100%;
    overflow-x: hidden;
    overflow-y: auto;
    outline: 0;
}
.profile-add-eggs-button{
    border: #ffe371 2px solid;
    background: #0a0e1c;
    border-radius: 28.5px;
    width: 206px;
    height: 64px;
    font-size: 42px;
    padding: 0;
    color: #ffe371;
    
}
.profile-disconnect-button{
    border: none;
    background: #2a396f;
    border-radius: 28.5px;
    width: 224px;
    height: 68px;
    font-size: 45px;
    color: white;
    margin-top: 20px;
    
}
.wallet-id{
  font-size: 45px;
  letter-spacing: normal;
  text-align: left;
  color: #fff;
}
.profile-footer{
    background: #131b36;
    width: 100%;
    height: 110px;
    bottom: 0;
    border-bottom-left-radius: 54px;
    border-bottom-right-radius: 54px;
    position: absolute;
}
.inside-profile-modal{
    top: 10%;
    width: 490px;
    height: 500px;
    margin: 20px;
    background: #0a0e1c;
    border-radius: 54px;
    border: solid 6px #ffe371;
    position: relative;
    box-shadow: 2px 2px 5pt 5pt #ead287;
}
.profile-header{
    background: #131b36;
    width: 100%;
    height: 120px;
    border-top-left-radius: 54px;
    border-top-right-radius: 54px;
    position: relative;
}
.profile-header span{
    font-size: 30px;
    color: #ffe371;
    margin-top: 50px;
}
.close-button{
    background: none;
    border: none;
    color: #fff;
    position: absolute;
    right: 20px;
    font-size: 41.5px;
    top: 0;
}
@media (max-width:800px) {
    .profile-header span{
        font-size: 20px;
    }
    .profile-disconnect-button{
        font-size: 23px;
        width: 150px;
    }
    .profile-add-eggs-button{
        font-size: 19px;
        height: 50px;
        width: 120px;
    }
}
</style>